import { createContext, useContext } from 'react';
import { DashboardPanel } from './DashboardPanel';

export const DashboardPanelContext = createContext<DashboardPanel | null>(null);

export function useDashboardPanel() {
  const context = useContext(DashboardPanelContext);

  if (!context) throw new Error('There is no DashboardPanelContext');

  return context;
}
